// Update the URL
export function actionUpdateAutoLaunchOnStartup() {
    if (window.location.search.indexOf('running') !== -1) return

    // Get current path
    const pathname = window.location.pathname

    // Get current search & append the running parameter to it
    const search = window.location.search !== '' ? `${window.location.search}&running` : '?running'

    // Get the current hash
    const hash = window.location.hash

    // Update the URL with /path/?search#hash
    window.history.replaceState(null, null, pathname + search + hash)
}

// Check whether we will be doing auto-startup
export function actionAutoLaunchOnStartup() {
    return window.location.search.indexOf('running') === -1
}



// WEBPACK FOOTER //
// ./src/actions/user-list.js